import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
Vue.use(VueRouter)

// 1. Define route components. These can be imported from other files
import BadRoute from './components/main/BadRoute'
import WelcomePlaceholder from './components/main/WelcomePlaceholder'
import CollectionBase from './components/collectionlist/CollectionBase'
import AdminView from './components/admin/AdminView'
import AdminUsers from './components/admin/AdminUsers'
import AdminLTI from './components/admin/AdminLTI'
import AdminHomePageContent from './components/admin/AdminHomePageContent'
import AdminLearningProgressions from './components/admin/AdminLearningProgressions'
import AdminLessonMasters from './components/admin/AdminLessonMasters'
import AdminUsage from './components/admin/AdminUsage'
import AdminCourseEditLog from './components/admin/AdminCourseEditLog'
import AdminResourceUsage from './components/admin/AdminResourceUsage'
import AdminTerms from './components/admin/AdminTerms'
import ChangeLog from './components/main/ChangeLog'
import LessonStandaloneView from './components/lessons/LessonStandaloneView'
import ResourceLinkView from './components/resources/ResourceLinkView'
import SparklBankStandaloneView from './components/resources/SparklBankStandaloneView'
import AdminSiteIssues from './components/admin/AdminSiteIssues'
import DirectivesWrapper from './components/directives/DirectivesWrapper'
import HighDemandCareerPathwaysTool from './components/standards/HighDemandCareerPathwaysTool'

// NOTE: we can also just intercept routes in the initialize_app service callback in App.vue; 
// we currently do this for /reslink/

// 2. Define some routes
const routes = [
	{ path: '*', component: BadRoute },
	// see MainView if new component routes are added...

	// { path: '', redirect: '/welcome' },
	{ path: '', name: 'welcome', component: WelcomePlaceholder },
	{ path: '/signin', name: 'signin', component: WelcomePlaceholder },
	// note: this signin_method prop is detected and acted on in LoginView
	{ path: '/signin/:signin_method', name: 'signin_method', component: WelcomePlaceholder, props:true },

	{ path: '/welcome', name: 'welcome_alt', component: WelcomePlaceholder },
	// { path: '/welcome', redirect: '' },
	{ path: '/home', name: 'home', component: WelcomePlaceholder, meta: { title: 'Home' } },
	{ path: '/courses', name: 'courses', component: WelcomePlaceholder, meta: { title: 'Course Content Collections' } },
	{ path: '/courses/:category', name: 'courses_cat', component: WelcomePlaceholder },
	{ path: '/courses/:category/:subcat', name: 'courses_subcat', component: WelcomePlaceholder },
	{ path: '/repos', name: 'repos', component: WelcomePlaceholder, meta: { title: 'Resource Repositories' } },
	{ path: '/mycollections', name: 'mycollections', component: WelcomePlaceholder, meta: { title: 'My Content Collections' } },
	// pd collections used to have a separate home; now it's an alias for repositories
	{ path: '/pd', name: 'pd_main', component: WelcomePlaceholder, meta: { title: 'Professional Development' }},
	{ path: '/admin', name: 'admin', component: WelcomePlaceholder, meta: { title: 'Admin Tools' } },
	{ path: '/standards', name: 'standards', component: WelcomePlaceholder, meta: { title: 'Standards' } },
	{ path: '/asset_manager', name: 'asset_manager', component: WelcomePlaceholder },
	{ path: '/support', name: 'support', component: WelcomePlaceholder },
	// Non-admin route for users who have been granted admin rights to the resource report, but are not superusers
	{ path: '/resource_usage', name: 'resource_usage', component: WelcomePlaceholder, meta: { title: 'Resource Usage' } },

	{ path: '/reslink/:reslink_resource_id', name: 'reslink_view', component: ResourceLinkView, props: true },
	{ path: '/lesson/:lesson_id', name: 'standalone_lesson_view', component: LessonStandaloneView, props: true },
	{ path: '/itembank/:sparkl_bank_activity_id', name: 'standalone_sparkl_bank_view', component: SparklBankStandaloneView, props: true },
	{ path: '/activity/:single_activity_id', name: 'single_activity', component: DirectivesWrapper, props: true },

	{ path: '/collection/:course_code/:unit_id', name: 'collection_view', component: CollectionBase, props: true },

	// aliases for old routes:
	{ path: '/course/:course_code/:unit_id', redirect: { name: 'collection_view' }, props: true },
	{ path: '/repo/:course_code/:unit_id', redirect: { name: 'collection_view' }, props: true },
	{ path: '/mycollection/:course_code/:unit_id', redirect: { name: 'collection_view' }, props: true },
	{ path: '/pd/:course_code/:unit_id', redirect: { name: 'collection_view' }, props: true },

	{ path: '/admin_base', name: 'admin_main', component: AdminView, children: [
		{ path: '/admin/users', name: 'admin_users', component: AdminUsers },
		{ path: '/admin/home_page', name: 'admin_home_page', component: AdminHomePageContent },
		{ path: '/admin/lp', name: 'admin_lp', component: AdminLearningProgressions },
		{ path: '/admin/usage', name: 'admin_usage', component: AdminUsage },
		{ path: '/admin/editlog', name: 'admin_edit_log', component: AdminCourseEditLog },
		{ path: '/admin/resource_usage', name: 'admin_resource_usage', component: AdminResourceUsage },
		{ path: '/admin/site_issue_reports', name: 'admin_site_issue_reports', component: AdminSiteIssues },
		{ path: '/admin/lessonmasters', name: 'admin_lessonmasters', component: AdminLessonMasters },
		{ path: '/admin/lti', name: 'admin_lti', component: AdminLTI },
		{ path: '/admin/terms', name: 'admin_terms', component: AdminTerms, beforeEnter: (to, from, next) => {
			if (store.state.site_config.enable_admin_term_management === 'yes') {
				next();
			} else {
				next(false)
			}
		} },
			] },
	{ path: '/changelog', name: 'changelog', component: ChangeLog },

	// with this path App.vue will just show the LTIChooserCureum component
	{ path: '/ltichooser', name: 'lti_chooser', component: WelcomePlaceholder },

	// note: this subdomain prop is detected in the $route.fullPath watcher in App.vue
	{ path: '/sd/:subdomain', name: 'subdomain_start', component: WelcomePlaceholder, props: true },

	// note: the identifiers here are detected in the $route.fullPath watcher in App.vue
	{ path: '/standards/:framework_identifier', name: 'standards_framework', component: WelcomePlaceholder },
	{ path: '/standards/:framework_identifier/:item_identifier', name: 'standards_item', component: WelcomePlaceholder },

	// special path for GA high demand career pathways tool
	{ path: '/hdcp', name: 'high_demand_career_pathways', component: HighDemandCareerPathwaysTool, props: true },
]

// 3. Create the router instance and pass the `routes` option
const router = new VueRouter({
	// for local development, base is '/'; on the server, base is /
	base: (document.location.href.indexOf('localhost') > -1) ? '' : '/',
	mode: 'history',
	routes // short for `routes: routes`
})

// override push and replace functions to avoid useless "NavigationDuplicated" errors
// https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue
const _push = router.__proto__.push
router.__proto__.push = function push (...args) {
	return _push.call(this, ...args).catch(error => {
		if (error.name !== 'NavigationDuplicated') throw error
	})
}

const _replace = router.__proto__.replace
router.__proto__.replace = function replace (...args) {
	return _replace.call(this, ...args).catch(error => {
		if (error.name !== 'NavigationDuplicated') throw error
	})
}

// 4. export router object for inclusion in main.js
export default router



// for vx routes
import HomeHome from './components/home/HomeHome'
import SupportPage from './components/home/SupportPage'
import CourseIndex from './components/collectionlist/CourseIndex'
import RepositoriesIndex from './components/collectionlist/RepositoriesIndex'
import MyCollectionsIndex from './components/collectionlist/MyCollectionsIndex'
import StandardsHomePlaceholder from './components/standards/StandardsHomePlaceholder'
import AssetManager from './components/assetManager/AssetManager.vue'
import ResourceUsage from './components/main/ResourceUsage'

// fn for using new 'vx' routes -- called in store.initialize after we've determined if we're using vx
window.use_vx_routes = () => {
	// Function to map new components to existing route names (Gemini)
	let update_route_components = (component_map) => {
		let updated_routes = routes.map((route) => {
			if (route.name && component_map[route.name]) {
				return {
					...route,
					component: component_map[route.name]
				}
			}
			return route
		})

		// Instantiate a temporary router instance to grab a fresh matcher
		let new_router = new VueRouter({
			mode: 'history',
			routes: updated_routes
		})

		// Swap the matcher to apply the updated components seamlessly
		router.matcher = new_router.matcher
	}
	
	update_route_components({
		welcome: HomeHome,
		welcome_alt: HomeHome,
		home: HomeHome,
		support: SupportPage,
		courses: CourseIndex,
		courses_cat: CourseIndex,
		courses_subcat: CourseIndex,
		repos: RepositoriesIndex,
		mycollections: MyCollectionsIndex,
		pd_main: RepositoriesIndex,

		standards: StandardsHomePlaceholder,
		standards_framework: StandardsHomePlaceholder,
		standards_item: StandardsHomePlaceholder,

		asset_manager: AssetManager,
		resource_usage: ResourceUsage,

		subdomain_start: HomeHome,
		
		admin: AdminView,
	})

	// Force router to resolve the current path again if the user is already on it
	router.replace(router.currentRoute.fullPath).catch((error) => {
		// Handle or ignore RedundantNavigation errors safely
	})
}
